import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const sendChat = async (sessionId, message) => {
  const { data } = await http.post("/chat", { session_id: sessionId, message });
  return data;
};

export const saveItinerary = async (payload) => {
  const { data } = await http.post("/itinerary", payload);
  return data;
};

export const pdfUrl = (itineraryId) => `${API}/itinerary/${itineraryId}/pdf`;

export const createCheckout = async (payload) => {
  const { data } = await http.post("/payments/checkout", payload);
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await http.get(`/payments/status/${sessionId}`);
  return data;
};

export const confirmBooking = async (payload) => {
  const { data } = await http.post("/booking/confirm", payload);
  return data;
};
